var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1715_520",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36.125,
    height: 34,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1715_520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.51595 28.3335V12.3252C4.08947 12.0654 3.73199 11.7349 3.44349 11.3335C3.15499 10.9321 3.01074 10.4599 3.01074 9.91683V5.66683C3.01074 4.88766 3.30551 4.22065 3.89505 3.66579C4.48459 3.11093 5.19329 2.8335 6.02116 2.8335H30.1045C30.9324 2.8335 31.6411 3.11093 32.2306 3.66579C32.8201 4.22065 33.1149 4.88766 33.1149 5.66683V9.91683C33.1149 10.4599 32.9707 10.9321 32.6822 11.3335C32.3937 11.7349 32.0362 12.0654 31.6097 12.3252V28.3335C31.6097 29.1127 31.3149 29.7797 30.7254 30.3345C30.1358 30.8894 29.4271 31.1668 28.5993 31.1668H7.52637C6.6985 31.1668 5.9898 30.8894 5.40026 30.3345C4.81072 29.7797 4.51595 29.1127 4.51595 28.3335ZM7.52637 12.7502V28.3335H28.5993V12.7502H7.52637ZM30.1045 9.91683V5.66683H6.02116V9.91683H30.1045ZM13.5472 19.8335H22.5784V17.0002H13.5472V19.8335Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.9f7947f5393ae5728c35bfffa46e7737.svg";
export { ForwardRef as ReactComponent };